import { useNavigate, useParams } from 'react-router-dom';
import { FormFieldsData } from 'framework/form';
import { SideDrawer } from 'framework/ui/mui-builder';

import { InviteClientUserFormValues } from '../types';
import useClientPortalService from '../useClientPortalService';
import InviteClientUsersDrawerContent from './InviteClientUsersDrawerContent';
import {
  ACCESS_INFO_ACTIONS,
  ACCESS_INFO_SECTIONS,
  useNewProjectUrl,
  useProjectSecurityContext,
} from 'domain/shared/newProject';
import { useClientPortalProjectDataContext } from '../../context/ClientPortalContext';
import { useState } from 'react';

const InviteClientUsersDrawer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const { getProjectClientPortalUrl } = useNewProjectUrl();
  const { inviteClientUsers } = useClientPortalService();
  const { isAccessGranted } = useProjectSecurityContext();
  const { budgetEndDate, refetchClientPortalContext } = useClientPortalProjectDataContext();

  const canManageClientPortal = isAccessGranted(ACCESS_INFO_SECTIONS.CLIENT_PORTAL, ACCESS_INFO_ACTIONS.MANAGE);

  const inviteUser = async (rawValues: FormFieldsData) => {
    const values = rawValues as { clients: InviteClientUserFormValues[] };

    return inviteClientUsers(id!, { requestedUsers: values.clients });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <SideDrawer
      title="Request client portal access"
      width={760}
      content={
        canManageClientPortal ? (
          <InviteClientUsersDrawerContent
            afterSubmit={{
              execute: () => {
                refetchClientPortalContext();
                handleClose();
              },
            }}
            submitFormFunc={inviteUser}
            budgetEndDate={budgetEndDate}
          />
        ) : null
      }
      isOpen={open}
      onClose={handleClose}
      transitionProps={{
        onExited: () => {
          navigate(getProjectClientPortalUrl(id), { preventScrollReset: true });
        },
      }}
    />
  );
};

export default InviteClientUsersDrawer;
